var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3 5.66683H4.66667M4.66667 5.66683H18M4.66667 5.66683V17.3335C4.66667 17.7755 4.84226 18.1994 5.15482 18.512C5.46738 18.8246 5.89131 19.0002 6.33333 19.0002H14.6667C15.1087 19.0002 15.5326 18.8246 15.8452 18.512C16.1577 18.1994 16.3333 17.7755 16.3333 17.3335V5.66683H4.66667ZM7.16667 5.66683V4.00016C7.16667 3.55814 7.34226 3.13421 7.65482 2.82165C7.96738 2.50909 8.39131 2.3335 8.83333 2.3335H12.1667C12.6087 2.3335 13.0326 2.50909 13.3452 2.82165C13.6577 3.13421 13.8333 3.55814 13.8333 4.00016V5.66683",
    stroke: "#DE350B",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/redTrash.fd5893b17f66402aa2d3668fba1be22f.svg";
export { ForwardRef as ReactComponent };